<template>
  <div class="managingPeople hp100 bbox" v-loading="loading">
    <!-- 卡片视图 -->
    <el-card>
      <!-- 搜索-->
      <el-row :gutter="20" type="flex" justify="space-between">
        <el-col>
          <!-- <el-button plain class="add-column-btn bbox" @click="gotoDetail('')" type="primary"> <i class="el-icon-plus fw900 f16"></i> 新增</el-button> -->
        </el-col>
        <el-col>
          <div class="flex align-center justify-end header-search-box">
            <div style="width:100%;display:flex; justify-around;align-center">
              <el-date-picker
              value-format="yyyy-MM-dd"
                v-model="searchInput.createDt"
                type="date"
                placeholder="选择日期"
              >
              </el-date-picker>
              <el-input
                placeholder="请输入项目"
                clearable
                v-model="searchInput.projectName"
                class="header-search-input ml10"
                @change="search"
              >
              </el-input>
              <el-input
                placeholder="请输入负责人"
                clearable
                v-model="searchInput.leaderTrueName"
                class="header-search-input ml10"
                @change="search"
          
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  class="textblue searchBtn"
                  @click="search()"
                ></el-button>
              </el-input>
            </div>
          </div>
        </el-col>
      </el-row>
      <!-- 用户列表区域 -->
      <div
        :style="{ height: height + 'px' }"
        style="margin-top: 20px"
        class="C"
      >
        <el-scrollbar style="height: 100%; width: 100%">
          <el-row style="width: 100%">
            <el-table
              :data="tableData"
              border
              fit
              highlight-current-row
              style="width: 100%"
              @sort-change="sortChange"
            >
              <el-table-column label="创建时间" align="center" prop="创建时间"  width="200">
                <template slot-scope="scope">
                  <span>{{ scope.row.createDt | dataFormat }}</span>
                </template>
              </el-table-column>
              <el-table-column label="项目名称" align="center" prop="项目名称"  width="200">
                <template slot-scope="scope">
                  <span>{{ scope.row.projectName}}</span>
                </template>
              </el-table-column>
              <el-table-column label="备注" align="center" prop="备注">
                <template slot-scope="scope">
                  <span>{{ scope.row.content }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="负责人名称"
                align="center"
                prop="负责人名称"
                width="100"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.leaderTrueName }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                align="center"
                class-name="small-padding fixed-width"
                width="300"
              >
                <template slot-scope="scope">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="分配人选"
                    placement="bottom"
                  >
                    <el-button type="warning" @click="assignDialog(scope.row)">分配人选</el-button>
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="标记完成"
                    placement="bottom"
                  >
                    <el-button type="primary" @click="finishMeeting(scope.row)">标记完成</el-button>
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="删除"
                    placement="bottom"
                  >
                    <el-button type="danger" @click="deleteMeeting(scope.row)"
                      >删除</el-button
                    >
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
          </el-row></el-scrollbar
        >
      </div>
      <div class="footerBox">
        <!-- 分页区域 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="queryInfo.currPage"
          :page-sizes="[100, 10, 20, 30, 50]"
          :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
      <!-- 分配人选列表 -->
      <el-dialog title="选择人员" :visible.sync="dialogVisible" width="50%" @close="cancelChoose">
        <el-form :model="searchInput1" label-width="5rem">
          <div style="margin:10px 0 0 10px">{{dialogRemark}}</div>
          <div style="padding: 1.25rem">
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="人员">
                  <el-input v-model="searchInput1.name" clearable @change="search1"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-button type="success" @click="search1">查询</el-button>
              </el-col>
            </el-row>
            <div style="height: 450px">
              <el-scrollbar style="height: 90%; width: 100%">
                <el-table
                  :data="tableDataTwo"
                  style="width: 95%"
                  @row-click="singleElection"
                  highlight-current-row
                  border
                >
                  <el-table-column align="center" width="50" label="选择">
                  <template slot-scope="scope">
                    <!-- 可以手动的修改label的值，从而控制选择哪一项 -->
                    <el-radio
                      class="radio"
                      v-model="templateSelection"
                      :label="scope.row.id"
                      >&nbsp;</el-radio
                    >
                  </template>
                </el-table-column>
                  <el-table-column align="center" prop="phone" label="登录账号">
                  </el-table-column>
                  <el-table-column align="center" prop="name" label="真实姓名">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="source"
                    label="所属部门"
                  >
                  </el-table-column>
                </el-table>
                
              </el-scrollbar>
              <el-pagination
                  @size-change="handleSizeChange1"
                  @current-change="handleCurrentChange1"
                  :current-page.sync="queryInfo1.currPage"
                  :page-sizes="[100, 50, 20, 10]"
                  :page-size="queryInfo1.pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total1"
                  next-text="下一页"
                  prev-text="上一页"
                >
                </el-pagination>
            </div>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="assignConfirm">选 择</el-button>
          <el-button @click="dialogVisible = false">取 消</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      height: window.innerHeight - 256, //表格高度
      value: "",
      searchInput: {
        projectName:'',
        createDt:'',
        leaderTrueName:''
      },
      tableData: [],
      loading: true,
      // 获取用户列表查询参数对象
      queryInfo: {
        // 当前页数
        currPage: 1,
        // 每页显示多少数据
        pageSize: 100,
        //查询条件
        condition: {
          id: "",
          createDt:'',
          projectName:''
        },
      },
      userlist: [],
      total: 0,
      // 添加用户对话框
      addDialogVisible: false,
      // 用户添加
      addUserForm: {
        username: "",
        password: "",
        email: "",
        mobile: "",
      },
      // 修改用户
      editDialogVisible: false,
      editUserForm: {},
      // 分配角色对话框
      setRoleDialogVisible: false,
      dialogVisible: false,
      tableData: [],
      // 分配人选表格分页
      queryInfo1: {
        // 当前页数
        currPage: 1,
        // 每页显示多少数据
        pageSize: 100,
        //查询条件
        condition: {
          name: ""
        },
      },
      searchInput1:{
        name:''
      },
      total1:0,
      dialogRemark:'',
      tableDataTwo: [],
      templateSelection:"",
      checkList:[],
    };
  },
  created() {
    // this.queryInfo.currPage=this.$route.query.currPage;
    //  this.queryInfo.pageSize=this.$route.query.pageSize;
    this.getListData();
    window.addEventListener("resize", this.getHeight);
  },
  mounted() {
    this.loading = false;
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight);
  },
  methods: {
    // 关闭分配人选对话框
    cancelChoose(){
      this.searchInput1.name = '';
      this.queryInfo1.pageSize = 100;
      this.queryInfo1.currPage =1
    },
    // 查询人员信息
    getMenberList() {
      this.$http.post("/userInfo/list", this.queryInfo1).then((res) => {
        console.log(res.data.data);
        if (res.data.code == 200) {
          this.total1 = res.data.data.count;
          this.queryInfo1.currPage = res.data.data.currPage;
          this.tableDataTwo = res.data.data.data;
          this.dialogVisible = true;
        }
      });
    },
    //条件查询
    search() {
      this.queryInfo.condition = this.searchInput;
      this.getListData();
    },
    // 监听 pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getListData();
    },
    // 监听 页码值 改变事件
    handleCurrentChange(newSize) {
      this.queryInfo.currPage = newSize;
      this.getListData();
    },
    search1() {
      this.queryInfo1.condition.name = this.searchInput1.name;
      this.getMenberList();
    },
    // 监听 pagesize改变的事件
    handleSizeChange1(newSize) {
      this.queryInfo1.pageSize = newSize;
      this.getMenberList();
    },
    // 监听 页码值 改变事件
    handleCurrentChange1(newSize) {
      this.queryInfo1.currPage = newSize;
      this.getMenberList();
    },

    // 监听排序
    sortChange() {},
    //跳转到详情
    gotoDetail(id) {
      var that = this;
      this.$router.push({
        path: "/meetingSummary/details",
        query: {
          id: id,
          currPage: that.queryInfo.currPage,
          pageSize: that.queryInfo.pageSize,
        },
      });
    },

    // 删除用户
    async del(id) {
      const confirmResult = await this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).catch((err) => err);
      if (confirmResult === "confirm") {
        var that = this;
        that.$http
          .post("/meetingSummary/delete", { id: id })
          .then(function (response) {
            that.$notify.success({
              title: "提示",
              message: "删除成功",
              showClose: true,
            });
            that.getListData();
          });
      }
    },
    getListData() {
      // 获取列表
      var that = this;
      that.queryInfo.condition.userCode = JSON.parse(localStorage.getItem('userCode')).value;
      that.$http
        .post("/meetingSummary/list", that.queryInfo)
        .then(function (response) {
          console.log(response.data.data);
          if (response.data.code == 200) {
            that.total = response.data.data.count;
            that.queryInfo.currPage = response.data.data.currPage;
            that.tableData = response.data.data.data;
          }
        });
    },
    // 监听表格高度
    getHeight() {
      this.height = window.innerHeight - 256;
    },
    //打开分配对话框
    assignDialog(row){
      console.log('row',row);
      this.dialogRemark = row.content;
      this.meetingId = row.id
      // this.dialogVisible = true;
      this.getMenberList()
    },
    // 勾选的人
    // 选择某个责任人
    singleElection(row) {
      this.templateSelection = row.id;
      this.checkList = this.tableDataTwo.filter(
        (item) => item.id === row.id
      );
      console.log(`该行的责任人为${row.id}`, this.checkList);
    },
    // 保存选择的人
    assignConfirm(){
      let sendData = {};
      sendData.leaderTrueName = this.checkList[0].name;
      sendData.leaderUserCode = this.checkList[0].loginName;
      sendData.id = this.meetingId;
      this.$http.post("/meetingSummary/update", sendData).then((res) => {
        console.log(res.data.data);
        if (res.data.code == 200) {
          this.dialogVisible = false;
          this.getListData();
          this.templateSelection = ''
        }
      });
    },
    // 标记已完成
    finishMeeting(row){
      let sendData = {};
      sendData.status = '1';
      sendData.id = row.id;
      this.$http.post("/meetingSummary/update", sendData).then((res) => {
        console.log(res.data.data);
        if (res.data.code == 200) {
          this.$notify.success({
              title: "提示",
              message: "标记成功",
              showClose: true,
            });
            this.getListData()
        }
      });
    },
    // 删除
    deleteMeeting(row){
      let sendData = {};
      sendData.id = row.id;
      this.$http.post("/meetingSummary/delete", sendData).then((res) => {
        console.log(res.data.data);
        if (res.data.code == 200) {
          this.$notify.success({
              title: "提示",
              message: "删除成功",
              showClose: true,
            });
            this.getListData()
        }
      });
    }
  },
};
</script>

<style lang="less" scoped>
.textblue {
  color: #008eff;
}
.managingPeople {
  .el-card {
    height: calc(100vh - 114px);
    position: relative;
    .el-select > .el-input {
      width: 200px;
    }
    .header-search-box .header-search-input {
      width: 325px;
    }
    input::placeholder {
      font-size: 12px;
    }
    .handle-btn .el-button.add-column-btn {
      width: 100%;
      font-size: 13px;
      background-color: transparent;
      color: #008eff;
      z-index: 102;
    }
    .footerBox {
      position: absolute;
      width: 100%;
      height: 78px;
      left: 20px;
      right: 20px;
      bottom: 0;
    }
  }
  .tableArea {
    /deep/.el-button {
      padding: 0;
    }
  }
}
/deep/.el-scrollbar__view {
  min-width: 100%;
}
/deep/.el-scrollbar__wrap {
  overflow-x: auto;
  height: calc(100%); //多出来的20px是横向滚动条默认的样式
  width: 100%;
}
/deep/.el-scrollbar .el-scrollbar__wrap .el-scrollbar__view {
  white-space: nowrap;
  display: inline-block;
}
</style>

